import { useEffect, useState } from "react";

export default function useActiveVendor() {

    const [vendorName, setVendorName] = useState(
        localStorage.getItem("active_vendor_name") || ""
    );

    const [vendorSlug, setVendorSlug] = useState(
        localStorage.getItem("active_vendor_name_link") || ""
    );

    useEffect(() => {

        const handleVendorChange = () => {

            setVendorName(
                localStorage.getItem("active_vendor_name") || ""
            );

            setVendorSlug(
                localStorage.getItem("active_vendor_name_link") || ""
            );

        };

        window.addEventListener(
            "vendorChanged",
            handleVendorChange
        );

        return () => {

            window.removeEventListener(
                "vendorChanged",
                handleVendorChange
            );

        };

    }, []);

    return {
        vendorName,
        vendorSlug,
    };

}